import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import CinemaBrand from "@/components/CinemaBrand";
import { Mail, Check, X, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterPreference() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/newsletter/status/${token}`);
      setState({ loading: false, ...data });
    } catch (e) {
      setState({ loading: false, error: e.response?.data?.detail || "Unbekannt" });
    }
  };
  useEffect(() => { load(); }, [token]); // eslint-disable-line

  const toggle = async (val) => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/newsletter/toggle/${token}`, { subscribed: val });
      setState((s) => ({ ...s, subscribed: data.subscribed }));
    } catch (e) {
      setState((s) => ({ ...s, error: e.response?.data?.detail || "Fehler" }));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-[#F5F0E6] flex items-center justify-center p-6">
      <div className="w-full max-w-lg card-lux p-8 md:p-10 text-center" data-testid="newsletter-preference">
        <div className="flex justify-center mb-6"><CinemaBrand size="md" stacked /></div>
        <div className="text-[10px] uppercase tracking-[0.4em] text-[#D4AF37] flex items-center justify-center gap-2 mb-6">
          <Mail size={12} /> Wochen-Newsletter
        </div>

        {state.loading && (
          <div className="py-10 text-[#A8A398] flex items-center justify-center gap-2"><Loader2 className="animate-spin" size={18} /> Lade …</div>
        )}

        {state.error && !state.loading && (
          <div className="py-10 text-[#EE9CA1]">{state.error}</div>
        )}

        {!state.loading && !state.error && (
          <div className="space-y-6">
            <div>
              <div className="font-heading text-3xl">Hallo {state.first_name || "Mitglied"}</div>
              {state.email && <div className="text-xs text-[#A8A398] mt-1">{state.email}</div>}
            </div>

            <div className={`inline-flex items-center gap-3 rounded-full border px-6 py-3 ${state.subscribed ? "border-[#D4AF37] text-[#D4AF37]" : "border-[#5B1319] text-[#EE9CA1]"}`}
              data-testid={`newsletter-current-${state.subscribed ? "on" : "off"}`}>
              {state.subscribed ? <><Check size={18} /> Aktiv abonniert</> : <><X size={18} /> Abgemeldet</>}
            </div>

            <p className="text-sm text-[#A8A398] max-w-md mx-auto leading-relaxed">
              {state.subscribed
                ? "Du erhältst jeden Montagmorgen das Wochenprogramm mit allen kommenden Filmen im MOVIE HOUSE."
                : "Du erhältst momentan keinen Wochen-Newsletter. Reservierungsbestätigungen und Geburtstagsgrüße kommen weiterhin."}
            </p>

            <button
              disabled={busy}
              data-testid="newsletter-toggle-btn"
              onClick={() => toggle(!state.subscribed)}
              className={`inline-flex items-center gap-2 px-6 py-3 rounded-md uppercase tracking-widest text-sm transitions-safe disabled:opacity-50 ${
                state.subscribed
                  ? "border border-[#5B1319] text-[#EE9CA1] hover:bg-[#5B1319]/20"
                  : "bg-[#D4AF37] text-black hover:bg-[#EEDC82]"
              }`}
            >
              {busy && <Loader2 className="animate-spin" size={14} />}
              {state.subscribed ? "Newsletter abbestellen" : "Newsletter abonnieren"}
            </button>

            <div className="text-[10px] text-[#575148] uppercase tracking-widest pt-4 border-t border-[#141414]">
              Ein-Klick genügt · jederzeit umkehrbar
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
